import { useConnectionCRUDActions } from '@mm/state/actions/ConnectionsCRUDActions';
import ConnectionModel, {
  IntegrationTypes,
} from '@mm/state/model/ConnectionModel';
import TagModel from '@mm/state/model/TagModel';
import { tagsOfKinds } from '@mm/state/selectors/tags';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { useSelector } from 'react-redux';
import { TagsSelector } from '../../../../../features/beta/modules/Integrations/NativeIntegrations/components/TagsSelector/TagsSelector';
import styles from './WidgetConnectionTags.module.css';

export const WidgetConnectionTags = ({
  widgetName,
  connection,
  type,
}: {
  widgetName: string;
  connection: ConnectionModel;
  type: IntegrationTypes;
}) => {
  const availableTags = useSelector((state: StoreState) =>
    tagsOfKinds(state, ['regular']),
  );
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const { update } = useConnectionCRUDActions();

  const updateConnection = async (tag: TagModel) => {
    const connectionTags = connection?.tags || [];
    const tagIndex = connectionTags.findIndex(
      connTag => connTag.name === tag.name,
    );

    const tags =
      tagIndex >= 0
        ? [
            ...connectionTags.slice(0, tagIndex),
            ...connectionTags.slice(tagIndex + 1),
          ]
        : [...connectionTags, { name: tag.name, sentAs: tag.name }];

    if (connection.id) {
      await update(
        activeFbPageId,
        {
          id: connection.id,
          tags,
        },
        type,
      );
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>Add Tag to contacts in {widgetName}</div>
      <div className={styles.row}>
        <TagsSelector
          onChange={tag => {
            if (tag) {
              updateConnection(tag);
            }
          }}
          onTagRemove={tag => {
            if (tag) {
              updateConnection(tag);
            }
          }}
          fbPageId={activeFbPageId}
          availableTags={availableTags}
          tags={(connection?.tags || [])?.map(tag => ({
            name: tag.name,
            unsaved: false,
            kind: 'regular',
          }))}
        />
      </div>
      <div className={styles.note}>
        All tags will be added to a tag group “Customers.ai”
      </div>
    </div>
  );
};
